import React from "react";
import PropTypes from "prop-types";

function Bar({ color, left, top, width, height, description }) {
  return (
    <div
      className="tw-absolute tw-overflow-hidden tw-transition-transform tw-duration-500"
      data-tooltip-class="plot-tooltip"
      data-tooltip={description}
      style={{
        transform: `translate(${0}px, ${-top}px)`,
        transition: "transform 0.5s ease color 0.5s ease",
        width,
        left,
        top: height,
        height,
        backgroundColor: color,
      }}
    />
  );
}

Bar.propTypes = {
  description: PropTypes.string.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

Bar.defaultProps = {};

export default Bar;
